import { createFileRoute, redirect } from "@tanstack/react-router";

// El dinero vive dentro de cada cliente: total, señal, pagos y pendiente.
export const Route = createFileRoute("/_authenticated/app/presupuestos")({
  beforeLoad: () => {
    throw redirect({ to: "/app/clientes" });
  },
});
